import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import {
  Flex,
  Box,
  Button,
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Text,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Icon,
  useDisclosure,
  useToast
} from '@chakra-ui/react'

import { OptionsIcon } from '../../components/Shared/Icons'
import { useMutateClient } from '../../hooks/products'
import DeleteModal from '../Shared/DeleteModal'

// Tabla de lista de clientes
const ProductsTable = ({ clients }) => {
  const history = useHistory()
  const toast = useToast()
  const [selectedClient, setSelectedClient] = useState(null)
  const { mutate } = useMutateClient('DELETE')
  const {
    isOpen: openDelete,
    onOpen: onOpenDelete,
    onClose: closeDelete
  } = useDisclosure()

  // Eliminar usuario
  const handleDelete = (clientId) => {
    mutate(clientId, {
      onSuccess: () => {
        toast({
          title: `Producto eliminado`,
          status: 'success',
          isClosable: true
        })
      },
      onError: () => {
        toast({
          title: `Error al eliminar producto`,
          status: 'error',
          isClosable: true
        })
      }
    })
    closeDelete()
  }

  const handleClickDelete = (client) => {
    setSelectedClient(client)
    onOpenDelete()
  }

  const handleClickEdit = (client) => {
    history.push(`/productos/${client.id}`)
  }

  return (
    <Flex bg={'#FFF'}>
      <Box w="100%">
        <TableContainer>
          <Table variant="simple" size="sm">
            <Thead>
              <Tr>
                <Th color="#36355F" fontWeight={'normal'}>
                  Servicio
                </Th>
                <Th color="#36355F" fontWeight={'normal'}>
                  Nombre comercial
                </Th>
                <Th color="#36355F" fontWeight={'normal'}>
                  Registro ISP
                </Th>
                <Th color="#36355F" fontWeight={'normal'}>
                  Ingrediente
                </Th>
                <Th color="#36355F" fontWeight={'normal'}>
                  Concentración
                </Th>
                <Th color="#36355F" fontWeight={'normal'}>
                  Formulación
                </Th>
                <Th color="#36355F" fontWeight={'normal'}>
                  Unidad
                </Th>
                <Th color="#36355F" fontWeight={'normal'}>
                  Peso
                </Th>
                <Th color="#36355F" fontWeight={'normal'}>
                  Opciones
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {clients.map((client) => (
                <Tr>
                  <Td>
                    <Text
                      fontSize={['13px', '20px']}
                      color="#36355F"
                      fontWeight="bold"
                    >
                      {client.service}
                    </Text>
                  </Td>
                  <Td>
                    <Text
                      fontSize={['13px', '20px']}
                      color="#36355F"
                      fontWeight="bold"
                    >
                      {client.commercial}
                    </Text>
                  </Td>
                  <Td>
                    <Text
                      fontSize={['13px', '20px']}
                      color="#36355F"
                      fontWeight="bold"
                    >
                      {client.ISP}
                    </Text>
                  </Td>
                  <Td>
                    <Text
                      fontSize={['13px', '20px']}
                      color="#36355F"
                      fontWeight="bold"
                    >
                      {client.ingredient}
                    </Text>
                  </Td>
                  <Td>
                    <Text
                      fontSize={['13px', '20px']}
                      color="#36355F"
                      fontWeight="bold"
                    >
                      {client.concentration}
                    </Text>
                  </Td>
                  <Td>
                    <Text
                      fontSize={['13px', '20px']}
                      color="#36355F"
                      fontWeight="bold"
                    >
                      {client.formulation}
                    </Text>
                  </Td>
                  <Td>
                    <Text
                      fontSize={['13px', '20px']}
                      color="#36355F"
                      fontWeight="bold"
                    >
                      {client.unit}
                    </Text>
                  </Td>
                  <Td>
                    <Text
                      fontSize={['13px', '20px']}
                      color="#36355F"
                      fontWeight="bold"
                    >
                      {client.weight}
                    </Text>
                  </Td>
                  <Td>
                    <Menu>
                      <MenuButton
                        as={Button}
                        bg="#FFFFFF"
                        leftIcon={
                          <Icon
                            fontSize="22"
                            as={OptionsIcon}
                            color="#374957"
                          />
                        }
                      />
                      <MenuList>
                        <MenuItem onClick={() => handleClickEdit(client)}>
                          Editar
                        </MenuItem>
                        <MenuItem onClick={() => handleClickDelete(client)}>
                          Eliminar
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </Box>
      {openDelete && (
        <DeleteModal
          isOpen={openDelete}
          onClose={closeDelete}
          message="¿Esta seguro de querer eliminar el producto?"
          handleDelete={handleDelete}
          selected={selectedClient}
        />
      )}
    </Flex>
  )
}

export default ProductsTable
